module.exports = __webpack_public_path__ + "static/media/backArrow.bf87bcaa.svg";